import { createSelector } from '@ngrx/store';
import { phoneNumberRegisterSelector } from './phone-number-register.reducer';

export const selectPhoneNumberRegisterIncludeInactive = createSelector(phoneNumberRegisterSelector, (state) => {
   return state.includeInactive;
});

export const selectFilters = createSelector(phoneNumberRegisterSelector, (state) => {
   return state.filters;
});

export const selectIsOnSystemPage = createSelector(phoneNumberRegisterSelector, (state) => {
   return state.isOnSystemPage;
});
